/** localStorage for trade-in question (/tradein). */
export const TRADEIN_STORAGE_KEY = 'npdsurvey:tradein';

export type TradeInAnswer = 'yes_help' | 'not_interested' | 'already_new';

export type TradeInAnswers = {
  tradeIn: TradeInAnswer;
};

export function readTradeInAnswers(): TradeInAnswers | null {
  try {
    const raw = localStorage.getItem(TRADEIN_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const t = (o as { tradeIn?: unknown }).tradeIn;
    if (t === 'yes_help' || t === 'not_interested' || t === 'already_new') {
      return { tradeIn: t };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeTradeInAnswers(data: TradeInAnswers): void {
  try {
    localStorage.setItem(TRADEIN_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearTradeInAnswers(): void {
  try {
    localStorage.removeItem(TRADEIN_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isTradeInComplete(): boolean {
  return readTradeInAnswers() != null;
}
